import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from "./state/store";

import BootstrapVueNext from 'bootstrap-vue-next';
import highlightPlugin from './utils/highlightPlugin';
import addMomentFilters from './utils/moment.filters';
import setupAppComponents from './utils/globalComponents';
import addAuthorizeDirective, { isInRoles } from './utils/authorize.directive'
import addSafeHtmlDirective from './utils/safeHtml.directive'
import addGlobalLabelsProps from './utils/labels.helpers'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const defaultToastOptions = {
    transition: "Vue-Toastification__bounce",
    maxToasts: 10,
    newestOnTop: true,
    filterToasts: toasts => {
        // Keep track of existing types or duplicated messages
        const types = {};
        const msgs = {};
        return toasts.reduce((aggToasts, toast) => {
            if (toast.isWs === true) {
                if (toast.content && toast.content.props && toast.content.props.innerHTML) {
                    if (!msgs[toast.content.props.innerHTML]) {
                        aggToasts.push(toast);
                        msgs[toast.content.props.innerHTML] = true;
                    }
                } else {
                    aggToasts.push(toast);
                }
                
            } else {
                // Check if type was not seen before
                if (!types[toast.type]) {
                    aggToasts.push(toast);
                    types[toast.type] = true;
                }
            }
            
            return aggToasts;
        }, []);
    }
}

import i18n from './i18n/i18n';
import { vMaska } from "maska";

import './assets/scss/app.scss';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import { useWebsocket } from './services/websocket';
import apiClient from './services/api-base';

import vueDebounce from 'vue-debounce'

var ws = useWebsocket();
ws.tryStart();

const app = createApp(App);

// Expose websocket client for optional access without registering as a Vue plugin
app.config.globalProperties.$ws = ws;

addMomentFilters(app);
addAuthorizeDirective(app);
addSafeHtmlDirective(app);
addGlobalLabelsProps(app);
setupAppComponents(app)

app.use(router)
    .use(store)
    .use(highlightPlugin)
    .use(BootstrapVueNext)
    .use(i18n)
    .use(Toast, defaultToastOptions)
    .use(FloatingVue)
    .directive('debounce', vueDebounce({ lock: true, defaultTime: 400 }))
    .directive("maska", vMaska)
    .mount('#app');

// In dev, avoid the red runtime overlay for expected auth errors.
// 401/403 are already handled via modal/toast in the API interceptor.
if (process.env.NODE_ENV !== 'production') {
    window.addEventListener('unhandledrejection', (event) => {
        const err = event?.reason;
        const status = err?.response?.status;
        const isAxios = err?.isAxiosError === true || err?.name === 'AxiosError';
        if (isAxios && (status === 401 || status === 403)) {
            event.preventDefault();
        }
    });
}

//checar se está conectado: nesse caso validar se tem que alterar dados ou se tem que aceitar nova versão dos termos
import logout from '@/utils/logout';
import Roles from './utils/roles';
var tk = localStorage.getItem('mention.token')
if (tk && tk != '' && !isInRoles(Roles.FillClientData) && !isInRoles(Roles.AcceptTerms) && !isInRoles(Roles.ResponderPesquisa)) {
    apiClient.get('me/check-revisao-termo', {}).then(({data}) => {
        // deslogarUser é o sinal do servidor de que a sessão não vale mais — contrato cancelado
        // depois do prazo de acesso ou cobrança não concluída. Sem ele aqui, o usuário seguia
        // usando a plataforma até a próxima requisição tomar 401 e cair no modal genérico de
        // não autorizado, em vez de ser levado ao login com o motivo certo.
        if (data.aceitarTermo || data.atualizarDados || data.responderPesquisa || data.deslogarUser) {
            logout()
            router.push({name: 'login'})
        }
    }).catch((err) => {
        // token expirado/invalidado pode retornar 401; evita Uncaught runtime error
        if (err && err.response && err.response.status === 401) {
            logout()
            router.push({name: 'login'})
        }
    })
}

import { enviarLogs } from './services/logs-service';
// Enviar logs a cada 5 minutos
setInterval(enviarLogs, 5 * 60 * 1000);
